// Separate hero images for each theme.
import heroFeedbackLight from "../assets/images/hero-feedback-light-pexels.jpeg";
import heroFeedbackDark from "../assets/images/hero-feedback-dark-pexels.jpeg";

export default function FeedbackPage() {
  return (
    <>
      <section className="relative mb-8 overflow-hidden rounded-2xl">
        {/* Background images – swapped by theme */}
        <img
          src={heroFeedbackLight}
          alt="Teacher providing feedback to student in bright classroom"
          className="theme-light-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />

        <img
          src={heroFeedbackDark}
          alt="Educator reviewing assignments late at night on laptop"
          className="theme-dark-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white" />
        <div className="relative z-10 p-6">
          <h1 className="text-2xl font-semibold text-gray-900">Student Feedback</h1>
          <p className="mt-1 text-gray-700">
            Draft personalised feedback and review AI-generated suggestions.
          </p>
          {/* Photo credits – light */}
          <p className="mt-2 text-xs text-gray-500 dark:hidden">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@annushka-ahuja"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Annushka Ahuja
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>

          {/* Photo credits – dark */}
          <p className="mt-2 hidden text-xs text-gray-400 dark:block">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@rdne"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              RDNE Stock project
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>
        </div>
      </section>

      <div className="space-y-4">
        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <h2 className="mb-2 font-medium">Quick feedback templates</h2>
          <ul className="list-disc pl-6 text-sm leading-relaxed text-gray-700">
            <li>Great understanding of key concepts.</li>
            <li>Consider providing more real-world examples to strengthen arguments.</li>
            <li>Ensure to reference primary literature appropriately.</li>
          </ul>
        </div>
      </div>
    </>
  );
}
